import moment from "moment";
import { OrderService } from "@/services/order.service";
import { OrderQueryTransformer } from "@/helpers/orders/query.transformer";

export const ordersListPageMixin = {
  orderService: OrderService,
  data: () => ({
    mode: "list",
    orders: [],
    selectedOrder: null,
    checkedOrders: [],
    filters: {
      comment: "",
      commentCreatedAtStart: "",
      commentCreatedAtEnd: "",
      search: "",
      orderType: "",
      activityType: "",
      problemCodeId: "",
      priority: "",
      releaseDateStart: "",
      releaseDateEnd: "",
      requiredFinishStart: "",
      requiredFinishEnd: "",
      modifiedAtStart: "",
      modifiedAtEnd: "",
      managed_by: "",
      assignedTo: "",
      returnToSite: "",
      claimId: "",
      billingOnHold: "",
      bigStorm: "",
      escalated: "",
      furtherWorkRequired: "",
      doNotSurvey: "",
      surchargeManhole: "",
      hasComments: "",
      outcomeCodeId: "",
      responsibilityCodeId: "",
      failureCodeId: "",
      repairCodeId: "",
      kpiStart: "",
      kpiFinish: "",
      kpiAppeal: "",
      hasAsset: "",
      assetCode: "",
      regionTagId: "",
      dateChangeRequest: "",
      tags: "",
      claimLinesTotal: "",
      claimLinesTotalComparison: "",
      billingCode: "",
      includeVoid: false,
      inDispute: false,
      readyToComplete: false,
      readyToClaim: false,
      pendingApproval: false,
      contractType: "",
      contractId: "",
      startCodeTypeValue: "",
      issuedBy: "",
      issuedTo: "",
    },
    approving: false,
    rejecting: false,
    completing: false,
    claiming: false,
    cancelling: false,
    exportLoading: false,
    billingCodeUpdating: false,
    orderSource: localStorage.getItem("__order_table_source") || "inbound"
  }),
  computed: {
    code() {
      let codes = [];

      this.orders.forEach(order => {
        if (order.billing_code != null) {
          if (!codes.find(element => element == order.billing_code)) {
            codes.push(order.billing_code);
          }
        }
      });

      return codes.sort().reverse();
    },
    asset() {
      let assetCode = [];

      this.orders.forEach(order => {
        if (order.assetCode != null) {
          order.assetCode.forEach(asset => {
            if (!asset.code) return;
            if (!assetCode.find(element => element.id == asset.code.id)) {
              asset.code.asset_id = asset.id;

              assetCode.push(asset.code);
            }
          });
        }
      });

      return assetCode.sort(function(a, b) {
        var nameA = a.code.toUpperCase(); // ignore upper and lowercase

        var nameB = b.code.toUpperCase(); // ignore upper and lowercase

        if (nameA < nameB) {
          return -1;
        }

        if (nameA > nameB) {
          return 1;
        }

        // names must be equal

        return 0;
      });

      // return assetCode;
    },
    managers() {
      let managers = [];

      this.orders.forEach(order => {
        if (order.managed_by) {
          // mark
          managers.push(order.managed_by);
        }
      });

      return managers;
    },
    user() {
      return this.$store.state.Auth.user;
    },
    canBulkComplete() {
      return this.$store.getters["Auth/hasPermission"](
        "can bulk complete"
      );
    },
    canBulkBlap() {
      // console.log('test');
      return this.checkedOrderIds.length && (this.filters.comment && this.filters.comment.includes("BLRQ") || this.filters.pendingApproval ) ;

      // return (
      //   this.filters.pendingApproval &&
      //   !!(this.filters.comment && this.filters.comment.includes("BLRQ")) &&
      //   this.checkedOrderIds.length
      // );

    },
    checkedOrderIds() {
      return this.checkedOrders.map(order => order.id);
    },
    fetchParams() {
      const filters = Object.keys(
        JSON.parse(JSON.stringify(this.filters))
      ).reduce((acc, key) => {
        if (this.filters[key] !== "") {
          acc[key] = this.filters[key];
        }
        return acc;
      }, {});

      if (this.orderSource === "outbound") {
        filters.external_firm_id = this.user.firm.id;
      } else {
        filters.firmId = this.user.firm.id;
      }

      return {
        ...OrderQueryTransformer.transform(filters)
      };
    },
    canIssueOrders() {
      return this.$store.getters["Auth/hasGivenContractPermission"]("contractee can create orders") || this.$store.getters["Auth/hasContractPermission"]("contractor can create orders");
      // return this.$store.getters["Auth/hasFirmPermission"]("can issue orders");
    },
    perPage() {
      return this.filters.pendingApproval ? 1000 : 100;
    },
    hasActiveFilters() {
      const keys = Object.keys(this.filters);

      for (let x = 0; x < keys.length; x++) {
        const value = this.filters[keys[x]];

        if (value) {
          // Check if value is array
          if (Array.isArray(value)) {
            if (value.length) {
              return true;
            }
          } else {
            return true;
          }
        }
      }

      return false;
    }
  },
  created() {
    this.resetFilters();
  },
  mounted() {
    if (this.$route.query.orderId) {
      this.selectDefault(this.$route.query.orderId);
    } else if (this.$route.query.id) {
      this.selectDefaultById(this.$route.query.id);
    } else {
      this.$nextTick(() => {
        this.fetchData();
      });
    }
  },
  watch: {
    "$route.query.orderId"(orderId) {
      this.selectedOrder = null;

      this.$nextTick(() => {
        this.resetFilters();
        this.$refs.filters.resetInputs();
        this.selectDefault(orderId);
      });
    },
    orderSource(orderSource) {
      localStorage.setItem("__order_table_source", orderSource);
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    selectedOrder(value) {
      if (value) {
        this.selectedOrder.editable =
          this.selectedOrder.status != "CLOSED_D" &&
          this.selectedOrder.status != "CLOSED_N" &&
          this.selectedOrder.status != "REJECTED" &&
          this.selectedOrder.status != "INCC_ASSIGNED";

        // console.log(this.selectedOrder);
      }
    },
    mode() {
      this.$nextTick(() => {
        this.fetchData();
      });
    },
  },
  methods: {
    selectDefault(orderId) {
      this.filters.search = orderId;
      this.$nextTick(async () => {
        await this.fetchData();
        if (orderId) {
          const selected = this.orders.find(order => order.orderId === orderId);
          if (selected) {
            this.selectedOrder = selected;
          }
        }
      });
    },
    selectDefaultById(id) {
      this.filters.search = id;
      this.$nextTick(async () => {
        await this.fetchData();
        if (id) {
          const selected = this.orders.find(order => order.id === id);
          if (selected) {
            this.selectedOrder = selected;
          }
        }
        let query = Object.assign({}, this.$route.query);
        delete query.id;
        this.$router.replace({ query });

        // let url = window.location.href.split("?");
        // window.history.pushState(null, null, url[0]);
      });
    },
    async fetchData() {
      // 2023-12-01 - Fetch data based on mode
      if (this.mode == "list") {
        this.fetchDashboardData();
        await this.fetchTableData();
      } else if (this.mode == "calendar") {
        this.fetchCalendarData();
      }
    },
    async fetchTableData() {
      await this.$refs.ordersTable.fetch();
    },
    fetchDashboardData() {
      this.$refs.dashboard.fetch();
    },
    fetchCalendarData() {
      this.$refs.calendar.$refs.calendar.generateCalendarItems(true);
    },
    approve() {
      this.approving = true;
      OrderService.bulkApproveBilling({ ids: this.checkedOrderIds }).then(
        response => {
          this.approving = false;
          this.fetchData();
        }
      );
    },
    reject() {
      this.rejecting = true;
      OrderService.bulkRejectBilling({ ids: this.checkedOrderIds }).then(
        response => {
          this.rejecting = false;
          this.fetchData();
        }
      );
    },
    async complete() {
      this.completing = true;

      try {
        const response = await OrderService.bulkComplete({ ids: this.checkedOrderIds });

        this.$buefy.toast.open({
          message: response.data.message,
          type: "is-info",
          position: "is-top-right"
        });

        this.fetchData();
      } catch (err) {}

      this.completing = false;
    },
    async claim() {
      this.claiming = true;

      try {
        const response = await OrderService.bulkClaim({ ids: this.checkedOrderIds });

        this.$buefy.toast.open({
          // message: "Orders have been claimed.",
          message: response.data.message,
          type: "is-info",
          position: "is-top-right"
        });

        this.fetchData();
      } catch (err) {}

      this.claiming = false;
    },
    async cancel() {
      this.cancelling = true;

      try {
        const response = await OrderService.bulkCancel({ ids: this.checkedOrderIds });

        this.$buefy.toast.open({
          message: response.data.message,
          type: "is-info",
          position: "is-top-right"
        });

        this.fetchData();
      } catch (err) {}

      this.cancelling = false;
    },
    async updateBillingCode(code) {
      this.billingCodeUpdating = true;

      try {
        await OrderService.updateBillingCodes({
          ids: this.checkedOrderIds,
          billing_code: code
        });

        this.$buefy.toast.open({
          message: "Billing code have been updated.",
          type: "is-info",
          position: "is-top-right"
        });

        this.fetchData();
      } catch (err) {}

      this.billingCodeUpdating = false;
    },
    resetFilters() {
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = "";
      });

      this.setDefaultReleaseDate();
    },
    setDefaultReleaseDate() {
      // Set default date for release start date filter
      this.filters.releaseDateStart = moment()
        .subtract(12, "months")
        .startOf("month")
        .format("YYYY-MM-DD");

      // Need to set default release end date so chart will show 13 months
      // this.filters.releaseDateEnd = moment()
      //   .endOf("month")
      //   .format("YYYY-MM-DD");
    },
    unSelect() {
      this.selectedOrder = null;
    },
    isFilterStatus(status = "") {
      if (status) {
        return !!(
          this.filters.comment && this.filters.comment.includes(status)
        );
      }
    },
    onFilter(filters) {
      this.mode = "list";
      this.filters = filters;
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    onFilterReset() {
      // [2021-11-05]
      // Reset has become quite complicated due to deep filter component nesting
      // and not having a simple way to tell child filters to re-initialise on
      // reset. Not as simple as setting all filter values to an empty value.
      // So, we're using a brutal page reload to get back to initial state.
      /*
      this.mode = "list";
      this.resetFilters();
      this.$nextTick(() => {
        this.fetchData();
      });
      */
      this.resetBrutally();
    },
    onFilterSelectIssuedTo(val) {
      if (this.$refs.ordersTable) {
        this.$refs.ordersTable.show_assigned_to = (val == this.$store.state.Auth.user.firmId);
      }
    },
    onTableFetch(data) {
      this.orders = data;
    },
    onDashboardFilter(filters) {
      this.filters = {
        ...this.filters,
        ...filters
      };
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    onDashboardReset(filters) {
      this.filters = {
        ...this.filters,
        ...filters
      };
      this.setDefaultReleaseDate();
      this.$nextTick(() => {
        this.fetchData();
      });
    },
    onDetailFetchedRelationships(order) {
      // selectedOrder should always be a reference to the table's selected data
      // so that changes to the selectedOrder will also reflect in the table
      // don't assign selectedOrder to a new order object, instead just modify the selectedOrder's properties
      Object.keys(order).forEach(key => {
        this.$set(this.selectedOrder, key, order[key]);
      });
    },
    onExport() {
      this.exportLoading = true;

      let params = this.fetchParams;

      params.order_by = this.$store.state.orderTableParams.order_by;
      params.sort_by = this.$store.state.orderTableParams.sort_by;

      OrderService.exportOrders(params).then(response => {
        let blob = new Blob([response.data]);
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `orders-export-${moment().format(
          "YYYY-MM-DD@HHmm"
        )}.csv`;
        link.click();
        link.remove();

        this.exportLoading = false;
      });
    },
    onDetailCancel() {
      this.unSelect();
      this.fetchData();
    },
    onDetailApproveBilling() {
      if (!this.$refs.filters) return;
      this.$refs.filters.fetchSelectOptions("selectClaimId");
    },
    onCalendarGenerateItems(payload) {
      // Sync calendar date to required_finish_date filters
      this.filters.requiredFinishStart = payload.startDate;
      this.filters.requiredFinishEnd = payload.endDate;
      console.log(payload, this.filters.requiredFinishStart, this.filters.requiredFinishEnd);
    },
    resetBrutally() {
      if (window.location.search) {
        // We might be looking at a specific order like ?orderId=12345
        // so we need to get back to the order index starting state.
        const resolved = this.$router.resolve({ name: 'order-list' });
        if (resolved && resolved.route && resolved.route.path) {
          window.location.href = resolved.route.path;
        }
      }
      else {
        window.location.reload();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/Orders/list-new/mixins/ordersListPageMixin.js